var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mfu-module"},[_c('VideoRecorder',{ref:"recorder",attrs:{"def":_vm.def},on:{"done":_vm.handleDone}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }